/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { InvitationAcceptToJSON, InvitationCreateToJSON, InvitationCreatedFromJSON, InvitationInfoFromJSON, OtpRequestToJSON, TokenFromJSON, } from '../models/index';
/**
 *
 */
export class InvitationsApi extends runtime.BaseAPI {
    /**
     * Public: create the member account from the invitation and sign them in.  OTP is required unless the invitation email was backend-proven and the submitted email is unchanged. The account gets its instrument plus the default groups only (never a privileged role). On success the new member is signed in as an *additive* multi-account session (no other account is logged out) and becomes the active account - no password is set and no email is sent, the account is passkey-first.
     * Accept Invitation
     */
    acceptInvitationApiV1InvitationsTokenAcceptPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['token'] == null) {
                throw new runtime.RequiredError('token', 'Required parameter "token" was null or undefined when calling acceptInvitationApiV1InvitationsTokenAcceptPost().');
            }
            if (requestParameters['invitationAccept'] == null) {
                throw new runtime.RequiredError('invitationAccept', 'Required parameter "invitationAccept" was null or undefined when calling acceptInvitationApiV1InvitationsTokenAcceptPost().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/v1/invitations/{token}/accept`.replace(`{${"token"}}`, encodeURIComponent(String(requestParameters['token']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: InvitationAcceptToJSON(requestParameters['invitationAccept']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => TokenFromJSON(jsonValue));
        });
    }
    /**
     * Public: create the member account from the invitation and sign them in.  OTP is required unless the invitation email was backend-proven and the submitted email is unchanged. The account gets its instrument plus the default groups only (never a privileged role). On success the new member is signed in as an *additive* multi-account session (no other account is logged out) and becomes the active account - no password is set and no email is sent, the account is passkey-first.
     * Accept Invitation
     */
    acceptInvitationApiV1InvitationsTokenAcceptPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.acceptInvitationApiV1InvitationsTokenAcceptPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Generate an invitation and (for the email channel) send it.
     * Create Invitation
     */
    createInvitationApiV1InvitationsPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['invitationCreate'] == null) {
                throw new runtime.RequiredError('invitationCreate', 'Required parameter "invitationCreate" was null or undefined when calling createInvitationApiV1InvitationsPost().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/invitations`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: InvitationCreateToJSON(requestParameters['invitationCreate']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => InvitationCreatedFromJSON(jsonValue));
        });
    }
    /**
     * Generate an invitation and (for the email channel) send it.
     * Create Invitation
     */
    createInvitationApiV1InvitationsPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createInvitationApiV1InvitationsPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Public: return prefill data for the signup form (does not consume).
     * Get Invitation
     */
    getInvitationApiV1InvitationsTokenGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['token'] == null) {
                throw new runtime.RequiredError('token', 'Required parameter "token" was null or undefined when calling getInvitationApiV1InvitationsTokenGet().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/v1/invitations/{token}`.replace(`{${"token"}}`, encodeURIComponent(String(requestParameters['token']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => InvitationInfoFromJSON(jsonValue));
        });
    }
    /**
     * Public: return prefill data for the signup form (does not consume).
     * Get Invitation
     */
    getInvitationApiV1InvitationsTokenGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getInvitationApiV1InvitationsTokenGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Public: send a one-time code to the address the invitee entered.  A fresh code supersedes any previous one for this invitation, so only the latest is valid.
     * Request Otp
     */
    requestOtpApiV1InvitationsTokenOtpPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['token'] == null) {
                throw new runtime.RequiredError('token', 'Required parameter "token" was null or undefined when calling requestOtpApiV1InvitationsTokenOtpPost().');
            }
            if (requestParameters['otpRequest'] == null) {
                throw new runtime.RequiredError('otpRequest', 'Required parameter "otpRequest" was null or undefined when calling requestOtpApiV1InvitationsTokenOtpPost().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/v1/invitations/{token}/otp`.replace(`{${"token"}}`, encodeURIComponent(String(requestParameters['token']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: OtpRequestToJSON(requestParameters['otpRequest']),
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Public: send a one-time code to the address the invitee entered.  A fresh code supersedes any previous one for this invitation, so only the latest is valid.
     * Request Otp
     */
    requestOtpApiV1InvitationsTokenOtpPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.requestOtpApiV1InvitationsTokenOtpPostRaw(requestParameters, initOverrides);
        });
    }
}
